export default {
  /*
   * 时长转字符串表示
   * @param {Number} value 毫秒数
   * @param {Object} [fmt] 格式
   */
  formatTime: function (value, fmt) {
    fmt = fmt || 'HH:mm:ss'
    if (value === undefined || value === null || value === '') {
      return value
    }
    // 毫秒
    var ms = Math.floor(value % 1000)
    // 秒
    var s = Math.floor((value / 1000) % 60)
    // 分
    var m = Math.floor((value / 1000 / 60) % 60)
    // 时
    var h = Math.floor((value / 1000 / 60 / 60) % 60)
    // 替换数据
    var o = {
      'H+': h,
      'm+': m,
      's+': s,
      'S': ms
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },

  /*
   * 文件大小转字符串表示
   * @param {Number} value 比特数
   */
  formatFileSize: function (value) {
    if (value === null || value === '' || value === 0) {
      return value
    }
    if (value < 100 * 1000) {
      return '<0.1M'
    } else if (value < 1000 * 1000 * 1000) {
      return (value / 1000 / 1000).toFixed(1) + 'M'
    } else if (value < 1000 * 1000 * 1000 * 1000) {
      return (value / 1000 / 1000 / 1000).toFixed(1) + 'G'
    } else {
      return (value / 1000 / 1000 / 1000 / 1000).toFixed(1) + 'T'
    }
  },

  /*
   * 文件名称截取
   */
  trimFileName: function (fullName, maxLength) {
    if (fullName === null || fullName === '') {
      return fullName
    }
    maxLength = maxLength || 15
    // 去除路径
    if (fullName.lastIndexOf('/') > 0) {
      fullName = fullName.substring(fullName.lastIndexOf('/') + 1)
    }
    if (fullName.length <= maxLength) {
      return fullName
    }
    // 获取后缀名
    var mainName = fullName; var suffixName = ''
    if (fullName.lastIndexOf('.') > 0) {
      mainName = fullName.substring(0, fullName.lastIndexOf('.'))
      suffixName = fullName.substring(fullName.lastIndexOf('.'))
    }
    // 裁剪名称
    var mainNameLength = maxLength - suffixName.length - 3
    return mainName.substring(0, mainNameLength) + '...' + suffixName
  },

  /*
   * 获取文件主名
   */
  getFileNameMain: function (fileName) {
    if (fileName === undefined || fileName === null || fileName === '') {
      return fileName
    }
    return fileName.lastIndexOf('.') < 0 ? fileName : fileName.substring(0, fileName.lastIndexOf('.'))
  },

  /*
   * 获取文件扩展名
   */
  getFileNameExt: function (fileName) {
    if (fileName === undefined || fileName === null || fileName === '') {
      return fileName
    }
    return fileName.lastIndexOf('.') < 0 ? '' : fileName.substring(fileName.lastIndexOf('.') + 1)
  },

  /*
   * 人民币格式化
   */
  formatCNY: function (value, decimalLength) {
    if (value === null || value === '') {
      return value
    }
    if (decimalLength != null) {
      value = Number(value).toFixed(decimalLength)
    }
    return '￥' + value
  },

  /*
   * 人民币转大写
   */
  formatCNYUpper: function (n) {
    var fraction = ['角', '分']
    var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    var unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟'] ]
    var head = n < 0 ? '欠' : ''
    n = Math.abs(n)

    var s = ''

    for (var i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
    }
    s = s || '整'
    n = Math.floor(n)

    for (var k = 0; k < unit[0].length && n > 0; k++) {
      var p = ''
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p
        n = Math.floor(n / 10)
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][k] + s
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
  },

  /*
   * 裁剪
   */
  trim: function (value, length, noEllipsis) {
    if (value === null || value === '' || value.length <= length) {
      return value
    }
    if (noEllipsis || value.length <= 3) {
      // 无省略号
      return value.substring(0, length)
    } else {
      // 有省略号
      return value.substring(0, length - 3) + '...'
    }
  }

}



// WEBPACK FOOTER //
// ./src/baize/src/StringUtil.js